import { render, staticRenderFns } from "./HomeworkItem.vue?vue&type=template&id=e6cb7f56&scoped=true&"
import script from "./HomeworkItem.vue?vue&type=script&lang=js&"
export * from "./HomeworkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6cb7f56",
  null
  
)

export default component.exports